export const EMPLOYMENT_TYPE = {
  FULL_TIME: getText('Full Time'),
  PART_TIME: getText('Part Time'),
  TEMPORARY: getText('Temporary'),
  CONTRACT: getText('Contract/Freelance'),
};
